import type { ReactNode } from "react";

import { cn } from "./lib/cn";

export interface DefinitionGridItem {
  /** Kararlı kimlik — React anahtarı. */
  key: string;
  label: string;
  value: ReactNode;
}

export interface DefinitionGridProps {
  items: readonly DefinitionGridItem[];
  columns?: 2 | 3 | 4;
  className?: string;
}

const columnClasses: Record<NonNullable<DefinitionGridProps["columns"]>, string> = {
  2: "grid-cols-1 sm:grid-cols-2",
  3: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
  4: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4",
};

/**
 * Etiket/değer ızgarası — mockup Müvekkil detayı "Temel Bilgiler", Alan Profili,
 * Sözleşme Bilgileri kartlarının içeriği. Gerçek `<dl>`: etiket/değer çiftleri anlamsal
 * olarak bir tanım listesi, iki sütunlu bir tablo değil — ekran okuyucu ilişkiyi
 * `<dl>/<dt>/<dd>` üçlüsünden anlıyor, iki `<div>`'den anlamıyor.
 */
export function DefinitionGrid({ items, columns = 2, className }: DefinitionGridProps) {
  return (
    <dl className={cn("grid gap-x-6 gap-y-4", columnClasses[columns], className)}>
      {items.map((item) => (
        <div key={item.key} className="min-w-0">
          <dt className="text-xs font-medium text-fg-muted">{item.label}</dt>
          <dd className="mt-0.5 truncate text-sm font-medium text-fg-strong">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
